var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"apply-form"}},[_c('NavBar'),_c('Banner'),_c('router-view'),_c('v-divider'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }